export const ABBREVIATIONS = [
    "AC",
    "AL",
    "AM",
    "AP",
    "BA",
    "CE",
    "ES",
    "GO",
    "MA",
    "MG",
    "MS",
    "MT",
    "PA",
    "PB",
    "PE",
    "PI",
    "PR",
    "RJ",
    "RN",
    "RO",
    "RR",
    "RS",
    "SC",
    "SE",
    "SP",
    "TO",
    "DF",
]

export const REGION_TO_ABBREVIATION_INDEX = [
    [0],                    // Acre
    [1],                    // Alagoas
    [2],                    // Amazonas
    [3],                    // Amapá
    [4],                    // Bahia
    [5],                    // Ceará
    [6],                    // Espírito Santo
    [7],                    // Goiás
    [8],                    // Maranhão
    [9],                    // Minas Gerais
    [10],                   // Mato Grosso do Sul
    [11],                   // Mato Grosso
    [12],                   // Pará
    [13],                   // Paraíba
    [14],                   // Pernambuco
    [15],                   // Piauí
    [16],                   // Paraná
    [17],                   // Rio de Janeiro
    [18],                   // Rio Grande do Norte
    [19],                   // Rondônia
    [20],                   // Roraima
    [21],                   // Rio Grande do Sul
    [22],                   // Santa Catarina
    [23],                   // Sergipe
    [24],                   // São Paulo
    [25],                   // Tocantins
    [26],                   // Distrito Federal
];
